var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.3731 6H6.2936C5.02892 6 4 6.74743 4 7.66723C4 8.58591 5.02892 9.33333 6.2936 9.33333H20.3731C21.6377 9.33333 22.6667 8.58591 22.6667 7.66723C22.6667 6.74739 21.6377 6 20.3731 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7063 14.333H11.6269C10.3622 14.333 9.33325 15.0805 9.33325 16.0002C9.33325 16.9189 10.3622 17.6663 11.6269 17.6663H25.7063C26.971 17.6663 27.9999 16.9189 27.9999 16.0002C27.9999 15.0803 26.971 14.333 25.7063 14.333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3731 22.667H6.2936C5.02892 22.667 4 23.4145 4 24.3342C4 25.2529 5.02892 26.0003 6.2936 26.0003H20.3731C21.6377 26.0003 22.6667 25.2529 22.6667 24.3342C22.6667 23.4145 21.6377 22.667 20.3731 22.667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBar);
export default __webpack_public_path__ + "static/media/menu-bar.4f4277bf02df9c35c5332cb6aa50da8e.svg";
export { ForwardRef as ReactComponent };